import { render, staticRenderFns } from "./BuyProductInfo.vue?vue&type=template&id=022fb9a5&scoped=true"
import script from "./BuyProductInfo.vue?vue&type=script&lang=js"
export * from "./BuyProductInfo.vue?vue&type=script&lang=js"
import style0 from "./BuyProductInfo.vue?vue&type=style&index=0&id=022fb9a5&prod&lang=less&scoped=true"
import style1 from "./BuyProductInfo.vue?vue&type=style&index=1&id=022fb9a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.21_c6nu2kfme4k2fztecbunkha7um/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022fb9a5",
  null
  
)

export default component.exports